import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { ConstantsService } from '../../services/constants.service';
import { SharedService } from '../../../../../tools/src/lib/shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from '../../../environments/environment';
import { NGB_DATEPICKER_DATE_ADAPTER_FACTORY } from '@ng-bootstrap/ng-bootstrap/datepicker/adapters/ngb-date-adapter';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment-mini-ts';

@Component({
  selector: 'app-generate-payment-link',
  templateUrl: './generate-payment-link.component.html',
  styleUrls: ['./generate-payment-link.component.scss']
})
export class GeneratePaymentLinkComponent implements OnInit {


  otpGenerateRequestInfo = {};
  generateReceiptInfo = {};

  otp_Form!:FormGroup;
  receipt_Form!:FormGroup;
  isSubmited:boolean=false;
  @Input() order_id;
  @Input() email;
  @Input() contactNumber;
  @Input() noOfSections;
  @Input() serviceType;
  @Input() totalPayableAmount;
  @Input() sendPaymentLink;
  @Input() generateReceipt;
  @Input() remainingPayableAmo;
  msg: string = "";
  isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  mobilenumber: string = null;
  mobile: string = null;
  isCareAthome:boolean=false;
  constructor(
    private fb:FormBuilder,
    public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.otp_Form=this.fb.group({
      mobilenumber:['', Validators.compose([Validators.required,]),],
      email:['',Validators.compose([Validators.required,]),],
      sections:[''],
      payableAmont:['']
    })
    this.mobile = this.contactNumber;
    // console.log('input mobile'+this.mobile )
    this.otp_Form.patchValue({
      mobilenumber:this.mobile,
      email:this.email
    })
    this.receipt_Form=this.fb.group({
      paymentMode:['',Validators.compose([Validators.required,]),],
      amount:['',Validators.compose([Validators.required,]),],
      paymentRefNo:['',Validators.compose([Validators.required,]),],
      reason:[''],
      sections:[''],
      date:[''],
      fileupload:['']
      // payableAmont:['']
    })
    this.receipt_Form.patchValue({
      paymentMode:"",
      date:new Date()
    })
   if(this.serviceType == '5' || this.serviceType == '6' || this.serviceType == '7' || this.serviceType == '8'){
    let eachSecctionAmount=(this.totalPayableAmount/this.noOfSections)
    this.noOfSections=Math.round( this.remainingPayableAmo/eachSecctionAmount);
    this.isCareAthome=true;
    if(this.sendPaymentLink){
      const sectionsControl = this.otp_Form.get('sections');
      sectionsControl.setValidators([Validators.required, this.maxValueValidator(this.noOfSections),this.nonZeroValidator()]);
      sectionsControl.updateValueAndValidity(); 
      this.otp_Form.patchValue({
        sections:this.noOfSections,
        payableAmont:(eachSecctionAmount*this.noOfSections).toFixed(2)
      })
    }else if(this.generateReceipt){
      const sectionsControl = this.receipt_Form.get('sections');
      sectionsControl.setValidators([Validators.required, this.maxValueValidator(this.noOfSections),this.nonZeroValidator()]);
      sectionsControl.updateValueAndValidity(); 
      this.receipt_Form.patchValue({
        sections:this.noOfSections,
        amount:(eachSecctionAmount*this.noOfSections).toFixed(2)
      })
    }
      
   }
  }
reportuploadedFile:any;
documentId:any;
  uploadReports(event: any) {
    
    this.reportuploadedFile = "";
    this.documentId = "";
    if (event.target.files.length > 0) {
      this.reportuploadedFile = event.target.files[0]
      console.log(this.reportuploadedFile)
      let formData: FormData = new FormData();
      formData.append('file', this.reportuploadedFile); 
      formData.append('document', this.reportuploadedFile);
      let cp = 'CP'
      let Prescription = 'Payment'
      formData.append('applicationName', cp);
      formData.append('documentType', Prescription);
      this.SpinnerService.show()
      this.omsServiceService.uploadDocument(formData).subscribe((res: any) => {
        this.SpinnerService.hide()
        if (res.status == 'SUCCESS') {
          this.documentId = res.uploaded_document_id;
          this.isSuccessMsg = true;
          this.toastr.success(res["reason"]);
        } else {
          this.isFailureMsg =true;
          this.toastr.error(res["reason"]);
          this.receipt_Form.patchValue({
            fileupload: ''
          })
        }
      } ,(err) => {
        this.SpinnerService.hide()
        this.receipt_Form.patchValue({
          fileupload: ''
        })
      }
      
      )
    }
  }
  OnlyNumericp(evt): any {
    if (!/^\d+$/.test(evt.key)) {
      return false;
    }
  } 
  OnlyNumeric(evt): any {
    if (!/^\d+$/.test(evt.key)) {
      return false;
    }
  }
  payableAmont(){
    // this.otpGenerateRequestInfo["careChildsCount"]=this.otp_Form.value.sections
    if(this.sendPaymentLink){
      let totalPayAmount=(this.remainingPayableAmo/this.noOfSections)*this.otp_Form.value.sections
      this.otp_Form.patchValue({
        payableAmont:totalPayAmount.toFixed(2)
      })
    }else if(this.generateReceipt){
      let totalPayAmount=(this.remainingPayableAmo/this.noOfSections)*this.receipt_Form.value.sections
      this.receipt_Form.patchValue({
        amount:totalPayAmount.toFixed(2)
      })
    }
   
  }
  maxValueValidator(max: number) {
    return (control: AbstractControl) => {
      const value = control.value;
      return value !== null && value > max ? { maxValue: true } : null;
    };
  }

  nonZeroValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = control.value !== 0 && control.value !== '0';
      return isValid ? null : { nonZero: true };
    };
  }
  submitPaymentLinkData() {
    console.log(this.otp_Form)
    this.isSubmited =true;
      this.SpinnerService.show();

    if(this.otp_Form.invalid){
      // return
      this.toastr.error('please fill the input...');
          this.SpinnerService.hide();
    }else{
    
      // "actionById": "11287",
      // "careAmount":"2000",
      // "careChildsCount":2
// console.log('otp number'+this.otp_Form.value.mobilenumber)
      this.otpGenerateRequestInfo["mode"] = "2";
      this.otpGenerateRequestInfo["channel"] = "SDM";
      this.otpGenerateRequestInfo["id"] = [this.order_id];
      this.otpGenerateRequestInfo["email"] = this.otp_Form.value.email;
      this.otpGenerateRequestInfo["phone"] = this.otp_Form.value.mobilenumber;
      this.otpGenerateRequestInfo["action"] = "OMS/api/operation.php/v1/orders/payments/link/send";
      this.otpGenerateRequestInfo["type"] = "post";
      this.otpGenerateRequestInfo["channelCode"] = "2";

      if(this.isCareAthome){
        this.otpGenerateRequestInfo["careChildsCount"]=this.otp_Form.value.sections
        this.otpGenerateRequestInfo["careAmount"]=this.otp_Form.value.payableAmont
      }

      // console.log(this.reassignVendorRequestInfo);
      this.omsServiceService.paymentDifference(this.otpGenerateRequestInfo).subscribe(
        (res) => {

        this.isSuccessMsg = res["message"];
        this.isSuccessMsg = true;
        //  this._router.navigate(["order-details", orderId]);

          // if (res["response"] == 1) {
          //   //alert(res["message"]);
          //   this.isSuccessMsg =true;
          //   // this.msg = res["message"];
            this.toastr.success(res["message"]);
          //   //this.modal.close();
          // } else {
          //   this.isFailureMsg =true;
          //   // alert(res["message"]);
          //    this.toastr.error(res["message"]);
          //   //this.modal.close();
          // }
          this.SpinnerService.hide();
          setTimeout(
          function(){ 
          location.reload(); 
          }, 1000);

        });
    }
  }

  modelClose() {
    this.modal.close();
  }
  submitGenerateReceipt(){
    console.log(this.receipt_Form)
    this.isSubmited =true;
      this.SpinnerService.show();
    if(this.receipt_Form.invalid){
      this.toastr.error('please fill the input...');
          this.SpinnerService.hide();
    }else{
      this.generateReceiptInfo["receiptamount"] = this.receipt_Form.value.amount;
      this.generateReceiptInfo["referencenumber"] = this.receipt_Form.value.paymentRefNo;
      this.generateReceiptInfo["paymentmode"] = this.receipt_Form.value.paymentMode;
      this.generateReceiptInfo["order_id"] = this.order_id;
      this.generateReceiptInfo["actionById"] = window.localStorage.getItem('actionById');
      this.generateReceiptInfo["actionByName"] = window.localStorage.getItem('actionByName');
      this.generateReceiptInfo["action"] = "OMS/api/operation.php/v1/generateReceipt";
      this.generateReceiptInfo["type"] = "post";
      this.generateReceiptInfo["source"] = "SDM";
      this.generateReceiptInfo["channelCode"] = "2";
      this.generateReceiptInfo["paymentDate"]=moment(this.receipt_Form.value.date).format('YYYY-MM-DD');
      if(this.documentId != undefined && this.documentId != null && this.documentId != ''){
        this.generateReceiptInfo["paymentDocType"]="Payment"
        this.generateReceiptInfo["paymentDocId"]=this.documentId
        this.generateReceiptInfo["paymentDocName"]=this.reportuploadedFile.name
      }
      if(this.isCareAthome){
        this.generateReceiptInfo["childCount"]=this.receipt_Form.value.sections
        // this.generateReceiptInfo["careAmount"]=this.receipt_Form.value.amount
      }
      this.omsServiceService.paymentDifference(this.generateReceiptInfo).subscribe(
        (res) => {
        console.log("generate receipt",res);
        if(res["status"]==1){
        this.isSuccessMsg = res["message"];
        this.isSuccessMsg = true;
        this.toastr.success(res["message"]);
        }
        else{
          this.isFailureMsg =true;
          this.toastr.error(res["message"]);
        }
        this.SpinnerService.hide();
          setTimeout(
          function(){ 
          location.reload(); 
          }, 1000);
        });
    }
  }

  selectpaymentmodeype(){}

}
